import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { EditAttendanceData } from './meetingService';

import { MeetingKey } from './keys';
import { MeetingService } from './meetingService';

export function useEditAttendance() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: EditAttendanceData) => MeetingService.editAttendance(data).then((response) => response.data),
    onSettled: (_data, _error, variables) => {
      void queryClient.invalidateQueries({
        queryKey: [MeetingKey.MEETINGS, variables.id],
      });
    },
  });
}
